import { httpClient } from "api/httpClient";
import { envSettings } from "core/EnvSettings";
import React from "react";
import { isNullUndEmpty } from "utils/general";

export const useStoragePlaces = (records) => {
	const [storagePlaces, setStoragePlaces] = React.useState({});

	// Fetch storage places when storage module is enabled
	React.useEffect(() => {
		if (!envSettings.REACT_APP_FF_STORAGE_MODULE || !records?.length) {
			return;
		}
		// records.flatMap - to add box_movement source pallet storage_place_id if source pallet not present on the current page
		const uniqueStoragePlaceIds = [
			...new Set([
				...records.map((p) => p.storage_place_id).filter((id) => !isNullUndEmpty(id)),
				...records.flatMap((p) =>
					(p.box_movements || [])
						.map((bm) => bm.storage_place_id)
						.filter((id) => !isNullUndEmpty(id))
				),
			]),
		];

		if (uniqueStoragePlaceIds.length === 0) {
			setStoragePlaces({});
			return;
		}

		const storagePlaceFilter = JSON.stringify({
			id: uniqueStoragePlaceIds,
			no_range: true,
		});
		const storagePlaceUrl = `/storage-places-lookup?filter=${encodeURIComponent(
			storagePlaceFilter
		)}`;

		httpClient(storagePlaceUrl)
			.then(({ json: storagePlacesData }) => {
				const storagePlacesMap = {};
				storagePlacesData.forEach((sp) => {
					storagePlacesMap[sp.id] = sp;
				});
				setStoragePlaces(storagePlacesMap);
			})
			.catch((err) => {
				console.error("Failed to load storage places:", err);
				setStoragePlaces({});
			});
	}, [records]);

	return storagePlaces;
};
